import {
  Box,
  Button,
  Modal,
  Stack,
  styled,
  TextField,
  Typography,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Input
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { convertToPlaces, getDiscountedPrice } from "../../helpers/helpers";
import { authHeader } from "../../helpers";
import { apiConstants } from "../../constants";

const style = {
  background: "#FFFFFF",
  boxShadow:
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
  borderRadius: "4px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1300px",
  height: "auto",
  justifyContent: "space-evenly",
  display: "flex",
  flexDirection: "column",
  padding: "10px",
};

const StyledTheaders = styled(TableCell)({
  fontSize: "14px",
  padding: "10px",
});

const StyledPriceButton = styled(Button)({
  color: "white",
  height: "40px",
  padding: "6px"
});

const SuccessModal = ({ ...props }) => {
  const { open, handleClose, item, updateItems, index, status, gstEnabled } = props;
  const {
    qty,
    unit_discount = 0,
    price,
    color = "",
    note = "",
    extra_charges_list,
    colors,    
    countryId,
  } = item;

  const [changeItem, updateItem] = useState({ ...item });
  const [unitDiscount, setUnitDiscount] = useState(unit_discount);
  const [quantity, setQuantity] = useState(parseInt(qty));
  const [extra, setExtra] = useState([]);
  const [extraCharges, setExtraCharges] = useState([]);
  const [selected, setSelected] = useState({ name: "" });

  const [toastState, setToastState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "right",
  });
  const [toastMessage, setToastMessage] = React.useState("");
  const handleToastClose = () => setToastState({ open: false });

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  let showExtra = extraCharges?.length > 0;

  useEffect(() => {
    getExtra();
    setExtraCharges(extra_charges_list);
  }, [extra_charges_list]);

  const getExtra = () => {    
    fetch(`${apiConstants.API_URL}/extra-charges`, requestOptions).then(
      (response) => {
        response.text().then((text) => {
          const res = text && JSON.parse(text);
          setExtra(res?.data);
        });
      }
    );
  };

  const colorsProps = {
    options: price?.fabric?.relatedColors || (colors || []),
    getOptionLabel: (option) => option?.english_name || "",
  };

  const updateAction = async () => {
    if (gstEnabled && item.qty != changeItem.qty) {
      const gstObj = {
        country_id: countryId,
        total_price: changeItem?.total_price,
      };

      const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(gstObj),
      };
      fetch(`${apiConstants.API_URL}/prices/gst-charges`, requestOptions).then(
        (res) => {
          res.text().then((gstText) => {
            const gstData = gstText && JSON.parse(gstText);
            if (!res.ok) {
              const error = (gstData && gstData.error) || res.statusText;
              const errorMessageGST = Object.values(error).map((errorKey) => {
                return errorKey[0];
              });
              setToastMessage(errorMessageGST);
              setToastState({
                open: true,
                vertical: "top",
                horizontal: "right",
              });
            } else {
              const updateItem = {
                ...changeItem,
                estimated_shipping_charges: gstData?.data?.total_shipping_charges,
                gst_amount: gstData?.data.toal_gst_amount,
                selected: true,
              };
              updateItems(index, updateItem);
              handleClose();
            }
          });
        }
      );
    } else {     
      updateItems(index, changeItem);
      handleClose();
    }
  };

  const onChange = (e) => {
    const { id, value } = e.target;
    if(parseInt(value) < 0){
      return;
    }

    if (id === "qty") {
      updateItem({
        ...changeItem,
        qty: parseInt(value),
        original_unit_price: 0,
        original_total_price: 0,
        total_price: 0,
        unit_price: 0 
      });
      setQuantity(parseInt(value));      
    } 
    else if (id === "discount") {
      const disc = value.replace(/[^0-9.]/g, "") * 100;
      setUnitDiscount(parseInt(disc));

      let newUnitPrice = getDiscountedPrice(
        changeItem.original_unit_price,
        disc
      );

      updateItem({
        ...changeItem,
        unit_discount: disc,
        discount_percentage: value,
        unit_price: newUnitPrice,
        total_price: (changeItem.qty * newUnitPrice),
      });
    }
  };

  const addExtraTotal = () => {
    let newselected = { ...selected, qty: quantity};
    if (selected.code && !extraCharges.some(x => x.id === selected.id && x.reference === selected.reference)) {
      let newArra = [...extraCharges];
      newArra.push(newselected);
      setExtraCharges(() => [...newArra]);

      let totalExtra = 0;
      newArra.map((e) => {
        totalExtra = totalExtra + e.cost* quantity;
        return "";
      });
      updateItem((state) => ({
        ...state,
        extra_charges: totalExtra,
        extra_charges_list: [...newArra],
      }));
      onChangeReference("");
    }
  };

  const removeExtra = (index) => {
    let newArray = [];

    if (index >= 0 && index < extraCharges.length) {
      newArray = extraCharges.toSpliced(index, 1);
    }

    setExtraCharges([...newArray]);
    let totalExtra = 0;
    newArray.map((e) => {
      totalExtra = totalExtra + e.cost;
      return "";
    });
    
    updateItem({
      ...changeItem,
      extra_charges: totalExtra,
      extra_charges_list: [...newArray],
    });
    onChangeReference("");
  };

  const onChangeExtra = (e) => {
    const { value } = e.target;
    setSelected((prevSelected) => ({
      ...value,
      reference: prevSelected?.reference || ""
    }));
  };

  const onChangeReference = (value) => {
    setSelected((prevSelected) => ({
      ...prevSelected,
      reference: value
    }));
  };

  const onChangeAllExtraQty = (value) => {
    const updatedExtraCharges = extraCharges.map((charge) => ({
      ...charge,
      qty: value
    }));
    
    setExtraCharges(updatedExtraCharges);
    
    const totalExtra = updatedExtraCharges.reduce(
      (total, charge) => total + charge.cost * (charge.qty || 1),
      0
    );
    
    updateItem((state) => ({
      ...state,
      extra_charges: totalExtra,
      extra_charges_list: updatedExtraCharges
    }));
  };

  const getPrice = () => {
    const price_id = changeItem?.price_id || changeItem.price.id;
    
    fetch(
      `${apiConstants.API_URL}/price/${price_id}/qty/${changeItem?.qty}`,
      requestOptions
    ).then((response) => {
      response.text().then((text) => {
        const data = text && JSON.parse(text);
        
        let newUnitPrice = data?.data?.unit_price;
        if(unitDiscount){
          newUnitPrice = getDiscountedPrice(
            data?.data?.unit_price,
            unitDiscount
          );
        }
        updateItem({
          ...changeItem,
          unit_price: newUnitPrice,
          price_id: data?.data?.price_id,
          original_unit_price: data?.data?.unit_price,
          original_total_price: data?.data?.unit_price * changeItem?.qty,
          total_price: (newUnitPrice) * changeItem?.qty,
        });
        onChangeAllExtraQty(changeItem?.qty);
      });
    });
  };

  return (
    <>
      <Modal
        open={!!open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            spacing={2}
            direction={"column"}
            justifyContent="space-between"
          >
            <Typography fontSize={"20px"}>{item?.item?.name}</Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTheaders>Color</StyledTheaders>
                  <StyledTheaders>Unit Price</StyledTheaders>
                  <StyledTheaders>Quantity</StyledTheaders>
                  <StyledTheaders>Price</StyledTheaders>
                  <StyledTheaders>Unit Discount</StyledTheaders>
                  <StyledTheaders>Discount Amount</StyledTheaders>
                  <StyledTheaders>Discounted Price</StyledTheaders>
                  <StyledTheaders>Notes</StyledTheaders>
                  {!changeItem.original_unit_price > 0 &&(
                    <StyledTheaders>Action</StyledTheaders>
                  )};
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>
                    {status === "edit" ? (
                      <Autocomplete
                        id="auto-complete"
                        {...colorsProps}
                        defaultValue={color}
                        autoComplete
                        includeInputInList
                        value={item?.colorObj}
                        onChange={(e, value) => {
                          updateItem({
                            ...changeItem,
                            color_id: value?.id,
                            color: value?.english_name,
                            colorObj: {
                              id: value?.id,
                              english_name: value?.english_name,
                            },
                          });
                        }}
                        sx={{ minWidth: "150px" }}
                        renderInput={(params) => (
                          <TextField
                            sx={{ padding: 0 }}
                            {...params}
                            placeholder="Colors"
                          />
                        )}
                      />
                    ) : (
                      <Autocomplete
                        id="auto-complete"
                        {...colorsProps}
                        defaultValue={color}
                        autoComplete
                        disabled
                        includeInputInList
                        value={item?.colorObj}
                        sx={{ minWidth: "150px" }}
                        renderInput={(params) => (
                          <TextField
                            sx={{ padding: 0 }}
                            {...params}
                            placeholder="Colors"
                          />
                        )}
                      />
                    )}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {convertToPlaces(changeItem?.original_unit_price)}
                  </TableCell>
                  <TableCell>
                    {status === "edit" ? (
                      <TextField
                        size="small"
                        type="number"
                        id="qty"
                        defaultValue={qty}
                        onChange={onChange}
                        sx={{ minWidth: "100px" }}
                      />
                    ) : (
                      <TextField
                        value={qty}
                        size="small"
                        disabled={true}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {convertToPlaces(changeItem?.original_total_price)}
                  </TableCell>
                  <TableCell>
                    {status === "edit" ? (
                      <TextField
                        size="medium"
                        type="number"
                        defaultValue={changeItem?.unit_discount / 100}
                        onChange={onChange}
                        id="discount"
                        sx={{ minWidth: "100px" }}
                      />
                    ) : (
                      <TextField
                        value={changeItem?.unit_discount / 100}
                        size="small"
                        type="number"
                        disabled={true}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {convertToPlaces((changeItem?.unit_discount * changeItem?.qty))}
                  </TableCell>
                  <TableCell>
                    {convertToPlaces(changeItem?.total_price)}
                  </TableCell>
                  <TableCell>
                    {status === "edit" ? (
                      <TextField
                        size="small"
                        type="text"
                        id="note"
                        defaultValue={note}
                        onChange={onChange}
                        sx={{ minWidth: "100px" }}
                      />
                    ) : (
                      <TextField
                        value={note}
                        size="small"
                        disabled={true}
                        sx={{ minWidth: "100px" }}
                      />
                    )}
                  </TableCell>
                  {!changeItem.original_unit_price > 0 &&(
                    <TableCell>
                      <StyledPriceButton
                        variant="contained"
                        onClick={() => getPrice()}
                        disabled={!changeItem.qty > 0}
                      >
                        GET PRICE
                      </StyledPriceButton>
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </Stack>
          {status === "edit" && (
          <Stack
            direction={"row"}
            sx={{ margin: "20px 0 10px", padding: "0 16px" }}
          >
            <FormControl fullWidth variant="standard">
              <InputLabel id="demo-simple-select-label">
                Select Extra Charges
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="item"
                size="small"
                value={selected}
                onChange={onChangeExtra}
                disabled={status !== "edit"}
                value={extra.find(e => e.id === selected.id) || ""}
              >
                {extra?.map((d, index) => (
                  <MenuItem key={index} value={d}>
                    {d?.name} - ({convertToPlaces(d?.cost)})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth variant="standard">
              <TextField
                variant="standard"
                label="Reference"
                style={{ width: "450px", margin: "0 16px"}}
                value={selected.reference || ""}
                onChange={(e) => onChangeReference(e.target.value)}
              />
            </FormControl>
            {status === "edit" && (
              <Button
                variant="outlined"
                onClick={() => addExtraTotal()}
                sx={{ minWidth: "160px" }}                
                disabled={!changeItem?.qty || !selected.reference}
              >
                ADD CHARGES
              </Button>
            )}
          </Stack>
          )}
          {showExtra && (
            <Stack sx={{ marginBottom: "15px", marginTop: "15px", padding: "0 16px" }}>
              <Divider>
                <Typography fontWeight={500} fontSize={"20px"}>
                  EXTRA CHARGES
                </Typography>
              </Divider>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Code</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Cost</TableCell>
                    <TableCell>Reference</TableCell>
                    {status === "edit" && <TableCell>Action</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {extraCharges.map((e, index) => (
                    <TableRow key={index}>
                      <TableCell>{e.code}</TableCell>
                      <TableCell>{e.name}</TableCell>
                      <TableCell>
                        {convertToPlaces(e.cost * (e.qty || 1))}
                      </TableCell>
                      <TableCell>{e.reference}</TableCell>
                      {status === "edit" && (
                        <>                          
                          <TableCell>
                            <DeleteIcon
                              color="warning"
                              onClick={() => removeExtra(index)}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      Add-ons {convertToPlaces(changeItem.extra_charges)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Stack>
          )}
          <Stack
            spacing={2}
            direction={"column"}
            justifyContent="space-between"
            sx={{ marginTop: "15px" }}
          >
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Button onClick={() => handleClose(!open)}>CLOSE</Button>
              {status === "edit" && (
                <Button
                  onClick={() => updateAction()}
                  color="success"
                  variant="contained"
                  style={{ color: "white" }}
                  disabled={(!changeItem.original_unit_price > 0) && changeItem.style}
                >
                  UPDATE
                </Button>
              )}
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

SuccessModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  body: PropTypes.string,
  updateItems: PropTypes.func.isRequired,
  index: PropTypes.number,
};

SuccessModal.defaultProps = {
  open: "",
  title: "",
  body: "",
  index: 0,
};

export default SuccessModal;
